"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
const common_buoy_dialog_1 = require("@buoyhealth/common.buoy-dialog");
const common_buoy_input_1 = require("@buoyhealth/common.buoy-input");
const FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const styled_components_1 = __importDefault(require("styled-components"));
const analytics_1 = require("../analytics");
const Lock_1 = __importDefault(require("../icons/Lock"));
const Stripe_1 = __importDefault(require("../icons/Stripe"));
const requests_1 = require("../requests");
const StyledModal = (0, styled_components_1.default)(common_buoy_dialog_1.Modal) `
  // This seems excessive but it's necessary to make sure this modal appears above ads
  z-index: 10000000000;
  .MuiPaper-root {
    margin: 16px;
    max-height: unset;
  }
  .MuiPaper-root > div > div {
    align-items: center;
  }
  .Mui-error {
    font-size: 14px;
  }
`;
const StyledFormFooter = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 16px;
  width: 100%;
  ${({ theme }) => theme.typography.variants.primary.small};
  color: ${({ theme }) => theme.palette.gray[70]};
`;
function CheckoutForm({ tipAmount, onClose, customerId, interviewToken, tippingPlacement, }) {
    const stripe = (0, react_stripe_js_1.useStripe)();
    const elements = (0, react_stripe_js_1.useElements)();
    const [email, setEmail] = (0, react_1.useState)("");
    const [emailError, setEmailError] = (0, react_1.useState)(false);
    const [message, setMessage] = (0, react_1.useState)("");
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            return;
        }
        setIsLoading(true);
        const emailValid = !email || email.match(/\S+@\S+\.\S+/);
        if (!emailValid) {
            setIsLoading(false);
            return setEmailError(true);
        }
        /*
          Note: Default stripe behavior is to redirect a user to the `return_url`,
          but we want them to stay on the same page so they can continue
          looking at their interview results. We can get around the default
          redirect behavior by passing the `redirect: "if_required"` arg below,
          but stripe still requires a `return_url` param on this endpoint.
          This is just a placeholder which doesn't actually get used, so we don't
          have to worry about it being hardcoded to production.
        */
        const { error, paymentIntent } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: "https://www.buoyhealth.com/symptom-checker/",
                receipt_email: email,
            },
            redirect: "if_required",
        });
        if (error || !emailValid) {
            if (error?.type === "card_error") {
                setMessage(error.message || "");
            }
            else if (error?.type !== "validation_error") {
                setMessage("An unexpected error occurred.");
            }
            setIsLoading(false);
        }
        else {
            // Associate this e-mail address with the payment in Stripe
            if (email) {
                (0, requests_1.updateCustomerEmail)({ customerId, email });
            }
            (0, analytics_1.trackSubmissionOfPayment)(interviewToken || "", tipAmount, tippingPlacement);
            onClose(paymentIntent.status);
        }
    };
    const handleEmailChange = (e) => {
        setEmailError(false);
        setEmail(e.target.value);
    };
    const onEmailFocus = () => {
        (0, analytics_1.trackFieldClick)(interviewToken || "", "email");
    };
    const onPaymentElementFocus = (e) => {
        (0, analytics_1.trackFieldClick)(interviewToken || "", e.elementType);
    };
    return ((0, jsx_runtime_1.jsx)(StyledModal, { open: true, onClose: () => onClose(), title: "Payment details", modalTitlePadding: "24px 0 16px 24px", children: (0, jsx_runtime_1.jsxs)("form", { id: "payment-form", onSubmit: handleSubmit, children: [(0, jsx_runtime_1.jsx)(common_buoy_input_1.EmailInput, { error: emailError, onChange: handleEmailChange, onFocus: onEmailFocus, label: "Email address (optional)" }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(react_stripe_js_1.PaymentElement, { id: "payment-element", options: { layout: "tabs" }, onFocus: onPaymentElementFocus }), (0, jsx_runtime_1.jsx)(common_buoy_button_1.CTAButton, { disabled: isLoading || !stripe || !elements, id: "submit", withBuoyTheme: true, fullWidth: true, sx: {
                        marginTop: "24px",
                    }, type: "submit", children: (0, jsx_runtime_1.jsx)("span", { id: "button-text", children: isLoading ? "Processing..." : `Tip $${tipAmount}` }) }), (0, jsx_runtime_1.jsxs)(StyledFormFooter, { children: [(0, jsx_runtime_1.jsx)(Lock_1.default, {}), `Payment data securely handled via `, (0, jsx_runtime_1.jsx)(Stripe_1.default, {})] }), message && ((0, jsx_runtime_1.jsx)(FormHelperText_1.default, { error: true, id: "payment-message", sx: { textAlign: "center", fontSize: "14px", marginTop: "10px" }, children: message }))] }) }));
}
exports.default = CheckoutForm;
//# sourceMappingURL=CheckoutForm.js.map